const processOrderStatus = ({ status }: { status: string }) => {
  const endpointParams: Partial<
    Record<'status' | 'refundStatus' | 'shippingStatus' | 'excludedRefundStatus', string>
  > = {};
  switch (status) {
    case 'ALL':
      endpointParams.status = 'CONFIRMED,COMPLETED,REJECTED';
      break;
    case 'RECEIVED':
    case 'COMPLETED':
      endpointParams.status = 'COMPLETED';
      endpointParams.shippingStatus = 'DISPATCHED';
      break;
    case 'APPROVED':
    case 'CONFIRMED':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'NOT_SHIPPED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'DISBURSED':
    case 'DISPATCHED':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'DISPATCHED';
      break;
    case 'REJECTED':
      endpointParams.status = 'REJECTED';
      endpointParams.shippingStatus = 'NOT_SHIPPED';
      break;
    default:
      endpointParams.status = status;
      break;
  }

  return endpointParams;
};

const getFormattedOrderStatus = ({ item }: { item: any }) => {
  const status = item.orderStatus;
  // Neo Loan status mapping (order status + shipping status)
  // Rejected: orderStatus = REJECTED, shippingStatus = NOT_SHIPPED
  // Approved: orderStatus = CONFIRMED, shippingStatus = NOT_SHIPPED
  // Disbursed: orderStatus = CONFIRMED, shippingStatus = DISPATCHED
  // Received: orderStatus = COMPLETED, shippingStatus = DISPATCHED
  if (status === 'REJECTED') {
    return 'REJECTED';
  }
  if (status === 'CONFIRMED') {
    return item.shippingStatus === 'DISPATCHED' ? 'DISBURSED' : 'APPROVED';
  }
  if (status === 'COMPLETED') {
    return 'RECEIVED';
  }
  return status;
};

export { processOrderStatus, getFormattedOrderStatus };
